import sessionManager from './SessionManager';
import { API_BASE_URL } from './Constants';

/**
 * Wrapper for fetch API with authentication and token refresh handling
 * @param {string} url - API endpoint URL (without base URL)
 * @param {Object} options - Fetch API options
 * @returns {Promise} - Promise resolving to API response
 */
export const authenticatedFetch = async (endpoint, options = {}) => {
  // Construct full URL if endpoint doesn't already include it
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;
  
  // Check if token is expired before making the request
  if (sessionManager.isTokenExpired()) {
    const refreshSuccess = await sessionManager.refreshToken();
    if (!refreshSuccess) {
      throw new Error('Authentication failed. Please log in again.');
    }
  }
  
  // Get the current access token
  const token = localStorage.getItem('access_token');
  
  // Set up headers with authentication
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  try {
    const response = await fetch(url, {
      ...options,
      headers
    });
    
    // If unauthorized error, try to refresh token and retry the request
    if (response.status === 401) {
      //console.log('Received 401, attempting token refresh...');
      const refreshSuccess = await sessionManager.refreshToken();
      
      // If refresh successful, retry the original request
      if (refreshSuccess) {
        const newToken = localStorage.getItem('access_token');
        
        // Retry the request with new token
        return fetch(url, {
          ...options,
          headers: {
            ...headers,
            'Authorization': `Bearer ${newToken}`,
          }
        });
      } else {
        // If refresh failed, throw an error
        throw new Error('Authentication failed. Please log in again.');
      }
    }
    
    return response;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};
